/* eslint-disable no-console */
const MEASURE_TESTIM_CLI_PERFORMANCE = process.env.MEASURE_TESTIM_CLI_PERFORMANCE;
const epoch = Date.now();
let last = Date.now();

export function log(...args: any[]) {
    if (!MEASURE_TESTIM_CLI_PERFORMANCE) {
        return;
    }
    const time = Date.now();
    console.log(`${time - epoch}\t\t\t${time - last}\t\t\t`, ...args);
    last = time;
}

export function measure(fn: () => void, fnName?: string) {
    if (!MEASURE_TESTIM_CLI_PERFORMANCE) {
        return;
    }
    const start = Date.now();
    try {
        fn();
    } finally {
        console.log(fnName || fn.name, 'took', Date.now() - start);
    }
}
